import script from "./AssignDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignDialog.vue?vue&type=script&setup=true&lang=js"

import "./AssignDialog.vue?vue&type=style&index=0&id=6fc6c7f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc6c7f0"]])

export default __exports__